import React from 'react'
import 'rc-steps/assets/index.css'
import styled from 'styled-components'
import ProgressBar from '@ramonak/react-progress-bar'

import { palette, fonts } from '../../styles/variables'
import { translate } from '../../utils/translation'
import { Text } from '../topography'

const StepWrapper = styled.div({
  width: '100%',
  height: 'fit-content',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  marginBottom: '40px',
})

const Title = styled.div({
  fontFamily: fonts.primaryBook,
  fontSize: '24px',
  lineHeight: '24px',
  margin: '24px 0',
  textAlign: 'center',
  whiteSpace: 'pre-wrap',
  maxWidth: '450px',
})

export default ({ steps, current }) => {
  return (
    <StepWrapper>
      <Title>{translate(steps[current - 1].title)}</Title>
      {steps[current - 1].description && (
        <Text
          fontSize="16px"
          lineHeight="28px"
          margin="0 0 32px 0"
          style={{
            maxWidth: '80%',
            textAlign: 'center',
          }}
        >
          {translate(steps[current - 1].description)}
        </Text>
      )}
      <ProgressBar
        completed={Math.max(1, (100 * current) / steps.length - 1)}
        height="2px"
        width="160px"
        bgColor={palette.orange}
        baseBgColor={palette.lightGray}
        isLabelVisible={false}
        className="progress-bar"
      />
    </StepWrapper>
  )
}
